import { AnchorNodeData, AnchorTypeNodeData } from '../tree.model';
import { BaseAnchor, BaseVersion } from 'src/models/anchor-and-version/base.model';
import { ChangeRequest } from 'src/models/change-request-dto/change-request.dto';
import { NodeType } from '../enums/node-type.enum';
import { TreeNode } from 'primeng/api';
import { TreeType } from '../enums/tree-type.enum';

export function createAnchorNodes(
    anchors: BaseAnchor<BaseVersion>[],
    node: TreeNode<AnchorTypeNodeData>
): TreeNode<AnchorNodeData>[] {
    const data = node.data!;
    const depth = data.depth + 1;
    const anchorType = data.anchorType;

    const res: TreeNode<AnchorNodeData>[] = anchors.map((a) => {
        return {
            key: `${depth}-${anchorType}-${a.key}`,
            label:
                anchorType === TreeType.ChangeRequest
                    ? (a as unknown as ChangeRequest).name
                    : a.displayName!,
            data: { anchor: a, anchorType: anchorType, depth: depth },
            leaf: anchorType === TreeType.ChangeRequest,
            type: NodeType.anchor,
            parent: node as TreeNode,
        };
    });

    return res;
}
